import Vue from "vue";
import router from "@/router";

/**
 * @description 紀錄使用者軌跡
 * @param {String} line_uuid 使用者 LineUuid
 */
const pageUserTrack = async ({ line_uuid } = {}) => {
  // 從 vue router 實體中取的目前路由 meta 資訊
  const { meta } = router.currentRoute;
  // 以傳入此方法的 line_uuid 為主，若無則使用定義在 Vue.prototype 上的 line_uuid 資訊
  const userID = line_uuid || Vue.prototype.$line_uuid;

  // 若無傳入參數或當下路由無 mate 資訊時會略過軌跡紀錄
  if (Vue.gtm && userID) {
    //- 設定 cookie
    document.cookie = `userID=${userID};expires=Thu, 18 Dec 2043 12:00:00 GMT`;

    // 發送 content-view 事件給 GTM
    Vue.gtm.trackEvent({
      // 自行定義的事件名稱
      event: "get-user-id",
      // 自訂事件欄位
      userID: userID,
    });
  } else {
    //- 刪除 cookie
    document.cookie = `userID=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
};

/**
 * @description 紀錄使用者H5頁面點擊軌跡
 * @param {String} line_uuid 使用者 LineUuid
 */
const h5UserClickTrack = async ({ line_uuid, h5btnID } = {}) => {
  // 從 vue router 實體中取的目前路由 meta 資訊
  const { meta } = router.currentRoute;
  // 以傳入此方法的 line_uuid 為主，若無則使用定義在 Vue.prototype 上的 line_uuid 資訊
  const userID = line_uuid || Vue.prototype.$line_uuid;
  const btnID = h5btnID;

  // 若無傳入參數或當下路由無 mate 資訊時會略過軌跡紀錄
  if (Vue.gtm && userID && btnID) {
    //- 設定 cookie
    document.cookie = `userID=${userID};expires=Thu, 18 Dec 2044 12:00:00 GMT`;

    // 發送 click 事件給 GTM
    Vue.gtm.trackEvent({
      event: 'h5-link-click',
      action: 'click',
      userID: userID,
      h5ID: btnID
    });
  } else {
    //- 刪除 cookie
    document.cookie = `userID=; expires=Thu, 01 Jan 1971 00:00:00 GMT`;
  }
};

export default { pageUserTrack, h5UserClickTrack };
